// extracted by mini-css-extract-plugin
export var cols = "columns-module--cols--9cd91";